import type { CatalogMetadata } from '../types';

export async function publishCatalog(catalog: CatalogMetadata): Promise<CatalogMetadata> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 120000);

  let response: Response;
  try {
    response = await fetch('/api/catalogs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(catalog),
      signal: controller.signal
    });
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      throw new Error('Caricamento online troppo pesante. Prova con un PDF piu leggero o diviso in meno pagine.');
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const data = JSON.parse(text);
      message = data.error || message;
    } catch {
      message = text;
    }
    throw new Error(message || 'Pubblicazione non riuscita.');
  }

  return response.json();
}
